/* Simply Trees homepage redesign: sale/seasonal switch, video modal, grow-zone lookup, product filters, state banner, reviews. */
(function () {
  'use strict';
  if (window.__sthLoaded) return; window.__sthLoaded = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };

  /* ---------- where the shopper is (shared with the header grow-zone app) ---------- */
  var ST = { AL: 'Alabama', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'Washington D.C.', FL: 'Florida', GA: 'Georgia', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming', AK: 'Alaska', HI: 'Hawaii' };
  /* first three digits of a ZIP -> state */
  var ZR = [[5,5,'NY'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,54,'VT'],[55,55,'MA'],[56,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,200,'DC'],[201,201,'VA'],[202,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,339,'FL'],[341,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,458,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[569,569,'DC'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,732,'OK'],[733,733,'TX'],[734,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function stateOf(zip) {
    var n = parseInt(String(zip).slice(0, 3), 10);
    for (var i = 0; i < ZR.length; i++) if (n >= ZR[i][0] && n <= ZR[i][1]) return ZR[i][2];
    return '';
  }
  /* the state collection to send them to (three states are split by region) */
  function stateHandle(st, zip) {
    var n = parseInt(String(zip).slice(0, 3), 10), base = 'plants-that-thrive-in-';
    if (st === 'CA') return base + (n <= 935 ? 'southern-california' : 'northern-california');
    if (st === 'OR') return base + (n >= 977 ? 'eastern-oregon' : 'western-oregon');
    if (st === 'WA') return base + (n >= 988 ? 'eastern-washington' : 'western-washington');
    if (st === 'DC') return base + 'washington-d-c';
    return base + (ST[st] || '').toLowerCase().replace(/[^a-z]+/g, '-');
  }
  var store = {
    get: function () {
      try { var zip = localStorage.getItem('growzone_zip') || '', zone = localStorage.getItem('growzone_zone') || ''; if (!/^\d{1,2}[ab]?$/i.test(String(zone).trim())) zone = ''; return zip ? { zip: zip, zone: zone, st: stateOf(zip) } : null; } catch (e) { return null; }
    },
    set: function (zip, zone) {
      try {
        localStorage.setItem('growzone_zip', zip);
        if (zone && /^\d{1,2}[ab]?$/i.test(String(zone).trim())) { localStorage.setItem('growzone_zone', zone); localStorage.setItem('growzone_message', '<p>Your growzone is set to ' + zone + '</p>'); }
      } catch (e) {}
    }
  };
  var here = store.get();
  function announce() { document.dispatchEvent(new CustomEvent('sth:zone', { detail: here })); }
  /* The header's grow-zone app saves a new ZIP/zone to localStorage without telling the page. Watch for that and refresh. */
  (function () {
    var last = JSON.stringify(here);
    function chk() {
      var now = store.get(), s = JSON.stringify(now);
      if (s === JSON.stringify(here)) { last = s; return; }
      if (s === last) return;
      last = s; here = now; announce();
    }
    setInterval(chk, 800);
    window.addEventListener('storage', chk);
    document.addEventListener('visibilitychange', chk);
    window.addEventListener('focus', chk);
  })();
  function lookup(zip) {
    return fetch('https://phzmapi.org/' + encodeURIComponent(zip) + '.json').then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); }).then(function (d) { return (d && d.zone) || ''; });
  }

  /* ---------- images: Shopify's image CDN sometimes fails the first request for a new size (502). Retry at a nearby size. ---------- */
  var RETRY_W = [600, 800, 720, 1000];
  function retryImg(i) {
    if (!i || !(i instanceof HTMLImageElement) || !(i.closest('.sth') || i.closest('.cart-section'))) return;
    var n = +(i.getAttribute('data-retry') || 0); if (n >= RETRY_W.length) return;
    i.setAttribute('data-retry', n + 1);
    setTimeout(function () {
      var u = i.currentSrc || i.getAttribute('src') || ''; if (!u || u.indexOf('/cdn/shop/') < 0) return;
      i.removeAttribute('srcset'); i.removeAttribute('sizes');
      var w = RETRY_W[n];
      u = /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      i.src = u;
    }, 350 * (n + 1));
  }
  document.addEventListener('error', function (e) { if (e.target && e.target.tagName === 'IMG') retryImg(e.target); }, true);
  function sweepImgs() { $$('.sth img, .cart-section img').forEach(function (i) { if (i.complete && i.naturalWidth === 0 && (i.currentSrc || i.getAttribute('src'))) retryImg(i); }); }

  /* ---------- modals ---------- */
  var lastFocus = null;
  function openModal(m) { lastFocus = document.activeElement; m.hidden = false; document.documentElement.style.overflow = 'hidden'; var x = $('.sth-modal__x', m); if (x) x.focus(); }
  function closeModal(m) { m.hidden = true; document.documentElement.style.overflow = ''; var f = $('[data-sth-video-frame]', m); if (f) f.innerHTML = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  document.addEventListener('click', function (e) { var c = e.target.closest('[data-sth-close]'); if (c) closeModal(c.closest('.sth-modal')); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.sth-modal:not([hidden])').forEach(closeModal); });

  /* ---------- hero ---------- */
  function initHero(root) {
    var promo = $('[data-sth-promo]', root);
    if (promo) {
      var ends = Date.parse(promo.getAttribute('data-ends') || ''), sale = $('[data-sth-sale]', promo), season = $('[data-sth-season]', promo);
      if (sale && !sale.hidden && ends && Date.now() > ends) { sale.hidden = true; if (season) season.hidden = false; }
    }
    var vw = $('[data-sth-video-wrap]', root), vb = vw && $('[data-sth-video]', vw);
    if (vb) vb.addEventListener('click', function () {
      vw.classList.add('is-playing');
      vw.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(vb.getAttribute('data-sth-video')) + '?autoplay=1&rel=0&playsinline=1&modestbranding=1" title="' + esc(vw.getAttribute('data-title')) + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      var f = $('iframe', vw); if (f) f.focus();
    });

    var zt = $('[data-sth-zone]', root); if (!zt) return;
    var form = $('[data-sth-zone-form]', zt), input = $('[data-sth-zip]', zt), msg = $('[data-sth-zone-msg]', zt), h = $('[data-sth-zone-h]', zt), p = $('[data-sth-zone-p]', zt), after = $('[data-sth-zone-after]', zt), btn = $('[data-sth-zip-btn]', zt);
    function paint() {
      msg.textContent = ''; msg.classList.remove('is-err');
      if (here && here.zone) {
        zt.classList.add('is-set'); after.hidden = false;
        h.textContent = "You're in Zone " + here.zone;
        p.textContent = 'ZIP ' + here.zip + (here.st && ST[here.st] ? ' · ' + ST[here.st] : '') + '. Plants that grow here are marked below.';
      } else {
        zt.classList.remove('is-set'); after.hidden = true;
        h.textContent = h.getAttribute('data-default'); p.textContent = p.getAttribute('data-default');
      }
    }
    paint();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var zip = (input.value || '').replace(/\D/g, '').slice(0, 5);
      if (zip.length !== 5) { msg.textContent = 'Enter a 5-digit ZIP code.'; msg.classList.add('is-err'); input.focus(); return; }
      var st = stateOf(zip);
      if (st === 'AK' || st === 'HI') { msg.textContent = "We ship to the lower 48 states, so we can't send plants to " + ST[st] + ' yet.'; msg.classList.add('is-err'); return; }
      if (!st) { msg.textContent = "We couldn't find that ZIP. Check it and try again."; msg.classList.add('is-err'); return; }
      btn.disabled = true; msg.textContent = 'Looking up your zone…'; msg.classList.remove('is-err');
      lookup(zip).then(function (zone) {
        store.set(zip, zone); here = { zip: zip, zone: zone, st: st }; paint(); announce();
        if (!zone) { msg.textContent = "We found your state but not your exact zone. Try a nearby ZIP."; }
      }).catch(function () {
        store.set(zip, ''); here = { zip: zip, zone: '', st: st }; paint(); announce();
        msg.textContent = "We couldn't look up your zone right now. We'll still show plants for " + ST[st] + '.';
      }).then(function () { btn.disabled = false; });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sth-change-zip]')) {
        e.preventDefault(); zt.classList.remove('is-set'); after.hidden = true; input.value = ''; zt.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { input.focus(); }, 350);
      }
    });
    var show = $('[data-sth-show-zone]', zt);
    if (show) show.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('sth:zone-filter')); });
  }

  /* ---------- products ---------- */
  function zoneNum(z) { var m = String(z || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
  function fit(card, zone) {
    if (!zone) return '';
    if (card.getAttribute('data-plant') === 'false') return 'any';
    var zones = (card.getAttribute('data-zones') || '').toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var txt = card.getAttribute('data-ztxt') || '', n = zoneNum(zone), m;
    if (zones.length ? zones.indexOf(zone.toLowerCase()) > -1 : (m = txt.match(/Zones?\s*(\d+)\s*[-–]\s*(\d+)/i)) && n >= +m[1] && n <= +m[2]) return 'yes';
    if (card.getAttribute('data-indoor') === 'true') return 'indoor';
    m = txt.match(/or\s+Zones?\s*(\d+)\s*[-–]\s*(\d+)[^.]*(indoor|pot|container)/i);
    if (m && n >= +m[1] && n <= +m[2]) return 'pot';
    return '';
  }
  var CHECK = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M1 6.5l3.2 3L11 2.5" fill="none" stroke="#4C956C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PIN = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5.3 7 13 7 13s7-7.7 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" fill="currentColor"/></svg>';
  function paintTag(c, zone) {
    var f = fit(c, zone), tag = $('[data-sth-ztag]', c);
    if (!tag) return f;
    if (f === 'any') { tag.hidden = true; return f; }
    if (f === 'yes') { tag.innerHTML = CHECK + 'Grows in Zone ' + esc(zone); tag.className = 'sth-ztag is-yes'; tag.hidden = false; }
    else if (f === 'indoor') { tag.innerHTML = PIN + 'Indoor plant, any zone'; tag.className = 'sth-ztag'; tag.hidden = false; }
    else if (f === 'pot') { tag.innerHTML = PIN + 'In a pot in Zone ' + esc(zone); tag.className = 'sth-ztag'; tag.hidden = false; }
    else if (zone) { tag.innerHTML = 'Not hardy outdoors in Zone ' + esc(zone); tag.className = 'sth-ztag is-no'; tag.hidden = false; }
    else tag.hidden = true;
    return f;
  }
  function blockedHere(c) {
    var ns = c.getAttribute('data-noship') || '', hs = here && here.zip ? stateOf(here.zip) : '';
    return !!(hs && ns && (',' + ns + ',').indexOf(',' + hs + ',') > -1);
  }
  function chipScroller(cw) {
    var cs = cw && $('[data-sth-chips]', cw), pv = cw && $('[data-sth-chips-prev]', cw), nx = cw && $('[data-sth-chips-next]', cw);
    if (!cs) return null;
    function edges() {
      var l = cs.scrollLeft > 4, r = cs.scrollLeft + cs.clientWidth < cs.scrollWidth - 4;
      cw.classList.toggle('has-more-l', l); cw.classList.toggle('has-more-r', r);
      if (pv) pv.hidden = !l; if (nx) nx.hidden = !r;
    }
    cs.addEventListener('scroll', edges, { passive: true }); window.addEventListener('resize', edges); edges();
    if (pv) pv.addEventListener('click', function () { cs.scrollBy({ left: -cs.clientWidth * 0.7, behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { cs.scrollBy({ left: cs.clientWidth * 0.7, behavior: 'smooth' }); });
    return cs;
  }
  function initProducts(root) {
    var grid = $('[data-sth-grid]', root), loaded = { '': true }, limit = parseInt(root.getAttribute('data-limit'), 10) || 8, chip = '', zoneOn = !!(here && here.zone);
    var zc = $('[data-chip-zone]', root), zl = $('[data-sth-zone-label]', root), empty = $('[data-sth-empty]', root), banner = $('[data-sth-state]', root);
    /* prompt shoppers without a zone to add their ZIP */
    var zp = null;
    if (zc && grid) {
      if (!document.getElementById('sth-zp-css')) {
        var zcss = document.createElement('style'); zcss.id = 'sth-zp-css';
        zcss.textContent = '.sth-zp{display:flex;align-items:center;gap:14px;background:#D3EDF7;border-radius:18px;padding:14px 16px;margin:0 0 20px}.sth-zp[hidden]{display:none}.sth-zp__ic{flex:0 0 38px;height:38px;border-radius:50%;background:#fff;color:#235540;display:grid;place-items:center}.sth-zp__t{flex:1;min-width:0;font-size:14px;line-height:1.4;color:#352E27}.sth-zp__t b{display:block;font-size:16px;color:#235540}.sth-zp .sth-btn{flex:0 0 auto;white-space:nowrap}@media(max-width:749px){.sth-zp{flex-wrap:wrap;padding:14px}.sth-zp__t{flex:1 1 calc(100% - 52px)}.sth-zp .sth-btn{width:100%}}';
        document.head.appendChild(zcss);
      }
      zp = document.createElement('div'); zp.className = 'sth-zp'; zp.hidden = true;
      zp.innerHTML = '<span class="sth-zp__ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg></span><span class="sth-zp__t"><b>Shopping for your yard?</b>Add your ZIP and we\'ll show the plants that grow in your zone.</span><button type="button" class="sth-btn sth-btn--dark sth-btn--sm" data-sth-zp-btn>Enter my ZIP</button>';
      grid.parentNode.insertBefore(zp, grid);
      zp.querySelector('[data-sth-zp-btn]').addEventListener('click', function () { zc.click(); });
    }
    var counts = {}; try { counts = JSON.parse(($('[data-sth-states]', root) || {}).textContent || '{}'); } catch (e) {}
    function render() {
      var zone = here && here.zone, shown = 0;
      $$('.sth-card', grid).forEach(function (c) {
        var f = paintTag(c, zone);
        var ok = (c.getAttribute('data-group') || '') === chip && (!zoneOn || !!f) && !blockedHere(c);
        c.hidden = !(ok && shown < limit); if (ok && shown < limit) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      if (zp) zp.hidden = !!zone;
      if (zc) { zl.textContent = zone ? 'Grows in Zone ' + zone : 'Show plants for my zone'; zc.classList.toggle('is-on', zoneOn); zc.setAttribute('aria-pressed', zoneOn ? 'true' : 'false'); }
      if (banner) {
        var st = here && here.st, hd = st && stateHandle(st, here.zip), c2 = hd && counts[hd];
        if (c2 && ST[st]) {
          var name = ST[st];
          $('[data-sth-state-h]', banner).textContent = 'Shopping from ' + name + '?';
          $('[data-sth-state-p]', banner).textContent = 'All ' + c2.n + ' plants that thrive in ' + name + ', in one place.';
          var b = $('[data-sth-state-btn]', banner); b.textContent = 'Shop ' + name + ' plants'; b.href = c2.u;
          $('[data-sth-change-zip]', banner).textContent = 'Not in ' + here.zip + '? Change ZIP';
          var el = $('[data-sth-state-link-empty]', root); if (el) el.href = c2.u;
          banner.hidden = false;
        } else banner.hidden = true;
      }
    }
    function load(b) {
      var h = b.getAttribute('data-chip');
      if (loaded[h]) return Promise.resolve();
      grid.setAttribute('aria-busy', 'true'); grid.classList.add('is-loading');
      return fetch(b.getAttribute('data-url') + (b.getAttribute('data-url').indexOf('?') > -1 ? '&' : '?') + 'section_id=st-home-chip-grid')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          $$('.sth-card', d).forEach(function (c) { c.setAttribute('data-group', h); grid.appendChild(document.importNode(c, true)); });
          loaded[h] = true;
        })
        .catch(function () {})
        .then(function () { grid.removeAttribute('aria-busy'); grid.classList.remove('is-loading'); });
    }
    $$('[data-chip]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        chip = b.getAttribute('data-chip');
        $$('[data-chip]', root).forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        $$('[data-sth-viewall]', root).forEach(function (a) { a.href = b.getAttribute('data-url') || a.getAttribute('data-default'); });
        load(b).then(function () { if (chip === b.getAttribute('data-chip')) render(); });
      });
    });
    var cw = $('[data-sth-chips-wrap]', root), cs = cw && $('[data-sth-chips]', cw), pv = cw && $('[data-sth-chips-prev]', cw), nx = cw && $('[data-sth-chips-next]', cw);
    function edges() {
      if (!cs) return;
      var l = cs.scrollLeft > 4, r = cs.scrollLeft + cs.clientWidth < cs.scrollWidth - 4;
      cw.classList.toggle('has-more-l', l); cw.classList.toggle('has-more-r', r);
      if (pv) pv.hidden = !l; if (nx) nx.hidden = !r;
    }
    if (cs) {
      cs.addEventListener('scroll', edges, { passive: true }); window.addEventListener('resize', edges); edges();
      if (pv) pv.addEventListener('click', function () { cs.scrollBy({ left: -cs.clientWidth * 0.7, behavior: 'smooth' }); });
      if (nx) nx.addEventListener('click', function () { cs.scrollBy({ left: cs.clientWidth * 0.7, behavior: 'smooth' }); });
      $$('[data-chip]', cs).forEach(function (b) { b.addEventListener('click', function () { var bl = b.offsetLeft, br = bl + b.offsetWidth; if (bl < cs.scrollLeft || br > cs.scrollLeft + cs.clientWidth) cs.scrollTo({ left: Math.max(0, bl - 40), behavior: 'smooth' }); }); });
    }
    if (zc) zc.addEventListener('click', function () {
      if (!(here && here.zone)) { var zt = $('[data-sth-zone]'); if (zt) { zt.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { var i = $('[data-sth-zip]', zt); if (i) i.focus(); }, 350); } return; }
      zoneOn = !zoneOn; render();
    });
    document.addEventListener('sth:zone', function () { zoneOn = !!(here && here.zone); render(); });
    document.addEventListener('sth:zone-filter', function () { if (here && here.zone) { zoneOn = true; render(); } });
    render();
  }

  /* ---------- collection pages ---------- */
  function initCollection(root) {
    var form = $('[data-stc-form]', root); if (!form) return;
    var mobile = window.matchMedia('(max-width: 749px)'), scrim = $('[data-stc-scrim]', root), open = null;
    function go() {
      $$('input[type="number"]', form).forEach(function (i) { i.disabled = i.value === ''; });
      form.submit();
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    var sort = $('[data-stc-sort]', form); if (sort) sort.addEventListener('change', go);

    /* filter panels */
    function place(pill, pop) {
      if (mobile.matches) { pop.style.top = ''; pop.style.left = ''; return; }
      var r = pill.getBoundingClientRect(), w = pop.offsetWidth || 320;
      pop.style.top = Math.round(r.bottom + 8) + 'px';
      pop.style.left = Math.round(Math.max(16, Math.min(r.left, window.innerWidth - w - 16))) + 'px';
    }
    function close() {
      if (!open) return;
      open.pop.hidden = true; open.pill.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.hidden = true; document.documentElement.style.overflow = '';
      var p = open.pill; open = null; return p;
    }
    $$('[data-stc-pill]', root).forEach(function (pill) {
      var pop = document.getElementById(pill.getAttribute('aria-controls')); if (!pop) return;
      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        var was = open && open.pill === pill; close(); if (was) return;
        pop.hidden = false; pill.setAttribute('aria-expanded', 'true'); open = { pill: pill, pop: pop };
        place(pill, pop);
        if (mobile.matches) { if (scrim) scrim.hidden = false; document.documentElement.style.overflow = 'hidden'; }
        var first = $('input:not([disabled])', pop); if (first && !mobile.matches) first.focus({ preventScroll: true });
      });
    });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-stc-close]')) { var p = close(); if (p) p.focus(); } });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('click', function (e) { if (open && !e.target.closest('[data-stc-pop]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) { var p = close(); if (p) p.focus(); } });
    window.addEventListener('resize', function () { if (open) place(open.pill, open.pop); });
    window.addEventListener('scroll', function () { if (open && !mobile.matches) place(open.pill, open.pop); }, { passive: true });
    var cs = chipScroller($('[data-sth-chips-wrap]', root));
    if (cs) cs.addEventListener('scroll', function () { if (open && !mobile.matches) place(open.pill, open.pop); }, { passive: true });

    /* grow-zone chip: turns on the store's own USDA zone filter for the shopper's zone */
    var zc = $('[data-stc-zone]', root), zl = $('[data-stc-zone-label]', root);
    function zoneOpt() {
      var n = here && here.zone ? zoneNum(here.zone) : 0;
      return n ? $$('[data-stc-zone-opt]', root).filter(function (i) { return i.value === 'Zone ' + n; })[0] : null;
    }
    function paintZone() {
      if (!zc) return;
      var z = here && here.zone, o = zoneOpt(), on = !!(o && o.checked);
      zl.textContent = z ? 'Grows in Zone ' + z : 'Show plants for my zone';
      zc.classList.toggle('is-on', on); zc.setAttribute('aria-pressed', on ? 'true' : 'false');
      zc.classList.toggle('is-none', !!(z && (!o || o.disabled)));
      zc.title = z && (!o || o.disabled) ? 'Nothing in this collection is listed for Zone ' + z : '';
    }
    if (zc) zc.addEventListener('click', function () {
      if (!(here && here.zone)) {
        var t = document.querySelector('.growzone-finder--toggler') || document.querySelector('.growzone-2--toggler') || document.querySelector('growzone-popup-widget button, growzone-popup-widget a');
        if (t) t.click();
        return;
      }
      var o = zoneOpt(); if (!o || o.disabled) return;
      o.checked = !o.checked; go();
    });

    /* cards: grow-zone tags, and hide plants we can't ship to the shopper's state */
    var note = $('[data-stc-noship]', root);
    function paintCards() {
      var zone = here && here.zone, hidden = 0;
      $$('.sth-card', root).forEach(function (c) {
        paintTag(c, zone);
        var b = blockedHere(c); c.hidden = b; if (b) hidden++;
      });
      if (note) {
        var name = here && here.zip ? ST[stateOf(here.zip)] : '';
        note.hidden = !hidden;
        if (hidden) note.textContent = (hidden === 1 ? '1 plant on this page is hidden because' : hidden + ' plants on this page are hidden because') + " we can't ship " + (hidden === 1 ? 'it' : 'them') + ' to ' + name + '.';
      }
    }
    var last = '';
    function sync() {
      var now = here ? here.zip + '|' + here.zone : '';
      if (now === last) return; last = now; paintZone(); paintCards();
    }
    sync();
    setInterval(function () { here = store.get(); sync(); }, 1500);
    document.addEventListener('sth:zone', sync);
  }

  /* ---------- reviews ---------- */
  function initReviews(root) {
    var company = root.getAttribute('data-company'); if (!company || !window.fetch) return;
    var photos = $('[data-sth-rv-photos]', root), list = $('[data-sth-rv-list]', root), rvm = $('[data-sth-rv-modal]', root), pm = $('[data-sth-photo-modal]', root);
    var img = function (u, w) { return 'https://reviews-media.services.klaviyo.com/abc/width:' + w + '/plain/https://klaviyo.s3.amazonaws.com/reviews/images/' + u; };
    var data = null;
    var load = fetch('https://fast.a.klaviyo.com/reviews/api/featured_reviews/?company_id=' + encodeURIComponent(company)).then(function (r) { return r.json(); }).then(function (d) {
      data = (d.reviews || []).filter(function (r) { return r.rating >= 4 && (r.content || r.smart_quote); });
      var used = {}, pics = data.filter(function (r) { if (!r.image_uuid || !r.product || used[r.product.handle]) return false; used[r.product.handle] = 1; return true; }).slice(0, 4);
      photos.innerHTML = pics.map(function (r) {
        return '<button type="button" data-full="' + img(r.image_uuid, 900) + '" data-cap="' + esc(r.author + ' · ' + (r.product ? r.product.name : '')) + '" aria-label="Open customer photo of ' + esc(r.product ? r.product.name : 'a plant') + '"><img src="' + img(r.image_uuid, 600) + '" alt="Customer photo of ' + esc(r.product ? r.product.name : 'a plant') + '" loading="lazy" width="300" height="300"></button>';
      }).join('');
      return data;
    }).catch(function () { return null; });
    photos.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-full]'); if (!b || !pm) return;
      var i = $('[data-sth-photo-img]', pm); i.src = b.getAttribute('data-full'); i.alt = b.getAttribute('aria-label').replace('Open ', '');
      $('[data-sth-photo-cap]', pm).textContent = b.getAttribute('data-cap'); openModal(pm);
    });
    /* full review list: 5-star with photos first, then newest 5-star, then 4 to 1 stars (photos first within each). */
    var API = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/all/?company_id=' + encodeURIComponent(company) + '&type=reviews&filter=&limit=50';
    var queue = [], seen = {}, shown = 0, done = false, started = false, summary = null, sentinel = null, io = null, note = null;
    /* live rating + review count from Klaviyo, refreshed at most every 48 hours */
    (function () {
      var KEY = 'sth_rv_summary_' + company, s = null;
      try { var c = JSON.parse(localStorage.getItem(KEY) || 'null'); if (c && Date.now() - c.t < 48 * 3600 * 1000) s = c.s; } catch (e) {}
      function paint(x) {
        if (!x || !x.count) return;
        var rating = (Math.round(x.rating * 10) / 10).toFixed(1);
        $$('[data-sth-rv-rating]').forEach(function (el) { el.textContent = rating; });
        $$('[data-sth-rv-count]').forEach(function (el) { el.textContent = el.textContent.replace(/\d[\d,]*(?=\s+reviews)/, Number(x.count).toLocaleString('en-US')); });
      }
      if (s) { paint(s); return; }
      fetch(API + '&offset=0&sort=0&media=false').then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.summary) return;
        var x = { count: d.summary.review_count, rating: d.summary.star_rating };
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), s: x })); } catch (e) {}
        paint(x);
      }).catch(function () {});
    })();
    function getPage(q, offset) {
      return fetch(API + '&offset=' + offset + '&' + q).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    function pages(q, max, onPage) {
      var off = 0;
      function next() {
        return getPage(q, off).then(function (d) {
          if (!summary && d.summary) { summary = d.summary; paintSummary(); }
          onPage(d.reviews || []);
          off += 50;
          if (d.has_more && off <= max) return next();
        }).catch(function () {});
      }
      return next();
    }
    function add(list) { list.forEach(function (r) { if (seen[r.id] || !(r.content || r.smart_quote || r.title)) return; seen[r.id] = 1; queue.push(r); }); if (shown < 20 || nearEnd()) renderMore(); else if (sentinel) sentinel.textContent = 'Scroll for more reviews'; }
    function nearEnd() { if (!sentinel || !sentinel.isConnected) return true; var box = list.closest('.sth-modal__box'); if (!box) return true; return sentinel.getBoundingClientRect().top - box.getBoundingClientRect().bottom < 400; }
    function stars(n) { return '<span class="sth-stars" role="img" aria-label="' + n + ' out of 5 stars">' + '★★★★★'.slice(0, n) + '<span class="sth-stars__off">' + '★★★★★'.slice(0, 5 - n) + '</span></span>'; }
    function item(r) {
      var t = (r.content || r.smart_quote || '').trim(), d = r.created_at ? new Date(r.created_at) : null;
      var when = d && !isNaN(d) ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
      var pic = r.image_uuid ? '<button type="button" class="sth-rv__pic" data-full="' + img(r.image_uuid, 900) + '" data-cap="' + esc(r.author + ' · ' + (r.product ? r.product.name : '')) + '" aria-label="Open customer photo of ' + esc(r.product ? r.product.name : 'a plant') + '"><img src="' + img(r.image_uuid, 200) + '" alt="" loading="lazy" width="84" height="84"></button>' : '';
      return '<div class="sth-rv__item"><div>' + stars(r.rating) + (r.title ? '<p class="sth-rv__t">' + esc(r.title) + '</p>' : '') + (t ? '<p>' + esc(t) + '</p>' : '') + '<small>' + esc(r.author) + (r.verified ? ' · Verified buyer' : '') + (when ? ' · ' + when : '') + (r.product ? ' · On <a class="sth-textlink" href="/products/' + encodeURIComponent(r.product.handle) + '">' + esc(r.product.name) + '</a>' : '') + '</small></div>' + pic + '</div>';
    }
    function paintSummary() {
      if (!summary || !rvm) return;
      if (!note) { note = document.createElement('p'); note.className = 'sth-rv__note'; var h = $('.sth-modal__h', rvm); if (h) h.insertAdjacentElement('afterend', note); }
      note.textContent = (Math.round(summary.star_rating * 10) / 10) + ' out of 5 from ' + Number(summary.review_count).toLocaleString('en-US') + ' reviews. 5-star reviews with photos first, lower ratings last.';
    }
    function renderMore() {
      if (!list) return;
      if (shown === 0 && queue.length) list.innerHTML = '';
      var html = '', n = 0;
      while (shown < queue.length && n < 20) { html += item(queue[shown]); shown++; n++; }
      if (html) { if (sentinel && sentinel.parentNode) sentinel.insertAdjacentHTML('beforebegin', html); else list.insertAdjacentHTML('beforeend', html); }
      if (!sentinel) { sentinel = document.createElement('p'); sentinel.className = 'sth-muted sth-rv__more'; list.appendChild(sentinel); if ('IntersectionObserver' in window) { io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) renderMore(); }, { root: list.closest('.sth-modal__box'), rootMargin: '400px' }); io.observe(sentinel); } }
      if (sentinel.parentNode !== list) list.appendChild(sentinel);
      sentinel.textContent = shown < queue.length ? 'Scroll for more reviews' : (done ? 'That’s every review we can show here.' : 'Loading more reviews…');
      if (!('IntersectionObserver' in window) && shown < queue.length) sentinel.innerHTML = '<button type="button" class="sth-link" data-sth-rv-more>Show more reviews</button>';
    }
    function start() {
      if (started) return; started = true;
      var photoLow = [];
      pages('sort=3&media=true', 400, function (rs) { add(rs.filter(function (r) { return r.rating === 5; })); photoLow = photoLow.concat(rs.filter(function (r) { return r.rating < 5; })); })
        .then(function () { return pages('sort=0&media=false', 500, function (rs) { add(rs.filter(function (r) { return r.rating === 5 && !r.image_uuid; })); }); })
        .then(function () {
          var low = [];
          return pages('sort=2&media=false', 500, function (rs) { low = low.concat(rs.filter(function (r) { return r.rating < 5; })); }).then(function () {
            var all = photoLow.concat(low);
            [4, 3, 2, 1].forEach(function (n) {
              var bucket = all.filter(function (r) { return r.rating === n; });
              add(bucket.filter(function (r) { return r.image_uuid; }).concat(bucket.filter(function (r) { return !r.image_uuid; })));
            });
          });
        })
        .then(function () { done = true; if (!queue.length) list.innerHTML = '<p class="sth-muted">Reviews are on each product page. Open any plant to read them.</p>'; else renderMore(); });
    }
    if (list) list.addEventListener('click', function (e) {
      if (e.target.closest('[data-sth-rv-more]')) { renderMore(); return; }
      var b = e.target.closest('button[data-full]'); if (!b || !pm) return;
      var i = $('[data-sth-photo-img]', pm); i.src = b.getAttribute('data-full'); i.alt = b.getAttribute('aria-label').replace('Open ', '');
      $('[data-sth-photo-cap]', pm).textContent = b.getAttribute('data-cap'); openModal(pm);
    });
    $$('[data-sth-rv-open]', root).forEach(function (b) {
      b.addEventListener('click', function () { openModal(rvm); start(); });
    });
  }

  /* ---------- live chat ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sth-chat]'); if (!a) return;
    var g = window.GorgiasChat;
    if (g && typeof g.open === 'function') { e.preventDefault(); try { g.open(); } catch (x) { location.href = a.href; } }
  });

  function boot() {
    sweepImgs();
    $$('[data-sth-hero]').forEach(initHero);
    $$('[data-sth-products]').forEach(initProducts);
    $$('[data-sth-collection]').forEach(initCollection);
    $$('[data-sth-reviews]').forEach(initReviews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', sweepImgs);
  document.addEventListener('shopify:section:load', boot);
})();
